import type { CqmEvidenceBundleRunDto } from '@medone/medonehp-api-client';

// Re-export the generated DTOs the evidence-bundle feature needs so components stay decoupled from
// the generated package's name (mirrors report-models). BundleFileDto is shared with the QRDA
// report feature — the backend packs the same file-row DTO into both bundles.
export type { BundleFileDto, CqmEvidenceBundleRunDto, CqmEvidenceBundleRunsSearchDto, CreateCqmEvidenceBundleRequest } from '@medone/medonehp-api-client';

export interface EvidenceBundleState {
    loading: boolean;
    processing: boolean;
    errorMessage: string | null;
    runs: CqmEvidenceBundleRunDto[];
    runsTotal: number;
    currentRun: CqmEvidenceBundleRunDto | null;
}

export const initialEvidenceBundleState: EvidenceBundleState = {
    loading: false,
    processing: false,
    errorMessage: null,
    runs: [],
    runsTotal: 0,
    currentRun: null,
};
